export default {
  horizontalMenuState: state => state.horizontalMenu,
  miniSidebarState: state => state.miniSidebarMenu,
  activePage: state => state.activePage,
  langState: state => state.lang,
  globalSearchState: state => state.globalSearch,
  bookmarkState: state => state.bookmark,
  // langOptionState: state => state.langOption,
  colorState: state => state.colors,
  darkModeState: state => state.layoutMode.dark,
  getDefaultNavbarHeight: state => state.defaultNavbarHeight,
  getMinistryPanelText: state => state.ministryPanelText
}
